import LoadableMonacoEditor from 'js/components/elements/editors/monaco/LoadableMonacoEditor';
import React from 'react';

type Props = {
  json: string;
  theme?: string;
};

export function JSONView({ json, theme }: Props) {
  if (!json) return null;

  return (
    <LoadableMonacoEditor
      value={json}
      height="100%"
      language="powershell"
      theme={theme}
      options={{ readOnly: true }}
    />
  );
}

JSONView.displayName = 'JSONView';
